// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { APP_ALLOWED_CURRENCIES } from '@/currency/constants/iso';
import { z } from 'zod';

// Mirrors `enums.Currency` on the BE: the curated subset offered as the org
// settings invoicing default, derived from the app-allowed dropdown set.
// The full multi-currency object lives in `@/currency/api/types`.
// TODO(#15932): Merge this enum into the `@/currency` package when
// the org settings card migrates to the multi-currency system.
export const orgDefaultCurrencyCodeSchema = z.enum(APP_ALLOWED_CURRENCIES);

export type OrgDefaultCurrencyCode = z.infer<
  typeof orgDefaultCurrencyCodeSchema
>;
